import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from '../../../ChildrenContext.js';
import PropTypes from 'prop-types';
import Parser from 'html-react-parser';
import typeOf from '../../../../helpers/typeOf';

const DashboardToday = ({ data, getData, t }) => {
    const [state, setState] = useState({
        sort: ['PublisherCreditTotalAmountConfirmed', 'ActionNameRegCountConfirmed', 'ActionTypeSaleCountConfirmed', 'Visits'],
        data: data
    });

    useEffect(() => {
        getData().catch(err => {
            console.warn('DashboardToday componentDidMount error:', err);
        });
    }, [getData]);

    useEffect(() => {
        if (data !== state.data) {
            setState(prevState => ({
                ...prevState,
                data: data
            }));
        }
    }, [data, state.data]);

    const renderMetricCard = useCallback((key) => {
        const metricData = (state.data && state.data[key]) || {};

        let level = '';
        if (metricData.diff > 0) {
            level = 'level-up';
        }
        if (metricData.diff < 0) {
            level = 'level-down';
        }

        return (
            <div className="ibox today" key={key}>
                <div className="inner">
                    <h5>{metricData.title}</h5>
                    <div className="ibox-content">
                        <div className="stat-percent">{metricData.subTitle} {metricData.diff}% <i
                            className={`levels ${level}`}/></div>
                        <div
                            className="stat-value">{typeOf.isString(metricData.today) ? Parser(metricData.today) : metricData.today}</div>
                    </div>
                </div>
            </div>
        );
    }, [state.data]);

    return (
        <div className="column">
            {(state.sort || []).map(renderMetricCard)}
        </div>
    );
};

DashboardToday.propTypes = {
    data: PropTypes.object,
    getData: PropTypes.func,
    t: PropTypes.object
};

DashboardToday.defaultProps = {
    data: {},
    getData: () => {}
};

export default withTranslation(DashboardToday);
